module.exports = __webpack_public_path__ + "img/data-variable.0cbd95c1.svg";